import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Umami (cloud.umami.is) - privacy-friendly, no cookies, RGPD-native.
// We skip loading the tracker on admin routes so internal navigation
// doesn't pollute the public traffic stats.
const UMAMI_SRC = "https://cloud.umami.is/script.js";
const UMAMI_ID = "dbb35d3f-e94b-463f-affd-82bb0c9a6c4b";
const SCRIPT_DATA_ATTR = "data-dataleo-umami";

const Analytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    const existing = document.querySelector(`script[${SCRIPT_DATA_ATTR}]`);

    if (isAdmin) {
      if (existing) existing.remove();
      // Also disable any in-flight Umami tracking for this tab.
      try {
        window.localStorage.setItem("umami.disabled", "1");
      } catch (err) {
        // localStorage may be unavailable in some browsers - best-effort.
        if (process.env.NODE_ENV === "development") {
          console.warn("Analytics: localStorage disable failed", err);
        }
      }
      return;
    }

    // Public page: ensure tracking is enabled and script is present.
    try {
      window.localStorage.removeItem("umami.disabled");
    } catch (err) {
      // Best-effort.
      if (process.env.NODE_ENV === "development") {
        console.warn("Analytics: localStorage remove failed", err);
      }
    }
    if (!existing) {
      const s = document.createElement("script");
      s.async = true;
      s.defer = true;
      s.src = UMAMI_SRC;
      s.setAttribute("data-website-id", UMAMI_ID);
      s.setAttribute(SCRIPT_DATA_ATTR, "1");
      document.head.appendChild(s);
    }
  }, [pathname]);

  return null;
};

export default Analytics;
